import { call, put, takeLatest, all } from "redux-saga/effects";
import { apiQueryWithToken } from "../../../common/services/apiBaseUrlConfig";
import { ENDPOINT } from "../../../common/services/endpoint.config";
import {
  getAdminUsersData,
  getAdminUsersDataFailure,
  getAdminUsersDataSuccess,
  getAddAdminGroupUserData,
  getAddAdminGroupUserDataSuccess,
  getAddAdminGroupUserDataFailure,
  getAllUsersData,
  getAllUsersDataSuccess,
  getAllUsersDataFailure,
  getUserHistoryData,
  getUserHistoryDataSuccess,
  getUserHistoryDataFailure,
  getEditUserData,
  getEditUserDataSuccess,
  getEditUserDataFailure,
  getDeleteUserData,
  getDeleteUserDataSuccess,
  getDeleteUserDataFailure,
  getAddUserData,
  getAddUserDataSuccess,
  getAddUserDataFailure,
  getDeleteAdminGroupUserData,
  getDeleteAdminGroupUserDataSuccess,
  getDeleteAdminGroupUserDataFailure,
  getUsersRolesData,
  getUsersRolesDataSuccess,
  getUsersRolesDataFailure,
  getPlannedOutageUsersData,
  getPlannedOutageUsersDataSuccess,
  getPlannedOutageUsersDataFailure,
  getAddPlannedOutageUserData,
  getAddPlannedOutageUserDataSuccess,
  getAddPlannedOutageUserDataFailure,
  getDeletePlannedOutageUserData,
  getDeletePlannedOutageUserDataSuccess,
  getDeletePlannedOutageUserDataFailure,
} from "./userManagementSlice";

function* getAdminUsers() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_ADMIN_GROUP_USERS)
    );
    const responseData = response.data;
    yield put(getAdminUsersDataSuccess(responseData));
  } catch (error) {
    yield put(getAdminUsersDataFailure(error.message));
  }
}

function* addAdminGroupUser(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.ADD_ADMIN_GROUP_USER, action.payload)
    );
    const responseData = response.data;
    yield put(getAddAdminGroupUserDataSuccess(responseData));
  } catch (error) {
    yield put(getAddAdminGroupUserDataFailure(error.message));
  }
}

function* getAllUsers() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_ALL_USERS)
    );
    const responseData = response.data;
    yield put(getAllUsersDataSuccess(responseData));
  } catch (error) {
    yield put(getAllUsersDataFailure(error.message));
  }
}

function* getUserHistory() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_USERS_HISTORY)
    );
    const responseData = response.data;
    yield put(getUserHistoryDataSuccess(responseData));
  } catch (error) {
    yield put(getUserHistoryDataFailure(error.message));
  }
}

function* getEditUser(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.EDIT_USER, action.payload)
    );
    const responseData = response.data;
    yield put(getEditUserDataSuccess(responseData));
  } catch (error) {
    yield put(getEditUserDataFailure(error.message));
  }
}

function* getDeleteUser(action) {
  try {
    const { userId, deleteDescription, email, userName } = action.payload;
    const response = yield call(() =>
      apiQueryWithToken.delete(ENDPOINT.DELETE_USER, {
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          userId: userId,
          lastModifiedBy: userName,
          comments: deleteDescription,
          email: email,
        },
      })
    );
    const responseData = response.data;
    yield put(getDeleteUserDataSuccess(responseData));
  } catch (error) {
    yield put(getDeleteUserDataFailure(error.message));
  }
}

function* getAddUser(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.ADD_USER, action.payload)
    );
    const responseData = response.data;
    yield put(getAddUserDataSuccess(responseData));
  } catch (error) {
    yield put(getAddUserDataFailure(error.message));
  }
}

function* getDeleteAdminGroupUser(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.DELETE_ADMIN_GROUP_USER, action.payload)
    );
    const responseData = response.data;
    yield put(getDeleteAdminGroupUserDataSuccess(responseData));
  } catch (error) {
    yield put(getDeleteAdminGroupUserDataFailure(error.message));
  }
}

function* getUsersRoles() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_USERS_ROLES)
    );
    const responseData = response.data;
    yield put(getUsersRolesDataSuccess(responseData));
  } catch (error) {
    yield put(getUsersRolesDataFailure(error.message));
  }
}

function* getPlannedOutageUsers() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_PLANNED_OUTAGE_USERS)
    );
    const responseData = response.data;
    yield put(getPlannedOutageUsersDataSuccess(responseData));
  } catch (error) {
    yield put(getPlannedOutageUsersDataFailure(error.message));
  }
}

function* addPlannedOutageUser(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.ADD_PLANNED_OUTAGE_USERS, action.payload)
    );
    const responseData = response.data;
    yield put(getAddPlannedOutageUserDataSuccess(responseData));
  } catch (error) {
    yield put(getAddPlannedOutageUserDataFailure(error.message));
  }
}

function* deletePlannedOutageUser(action) {
  try {
    const { id } = action.payload;
    const response = yield call(() =>
      apiQueryWithToken.delete(`${ENDPOINT.DELETE_PLANNED_OUTAGE_USERS}/${id}`)
    );
    const responseData = response.data;
    yield put(getDeletePlannedOutageUserDataSuccess(responseData));
  } catch (error) {
    yield put(getDeletePlannedOutageUserDataFailure(error.message));
  }
}

function* watchAdminUsers() {
  yield takeLatest(getAdminUsersData.type, getAdminUsers);
}

function* watchAddAdminGroupUser() {
  yield takeLatest(getAddAdminGroupUserData.type, addAdminGroupUser);
}

function* watchGetAllUsers() {
  yield takeLatest(getAllUsersData.type, getAllUsers);
}

function* watchGetUserHistory() {
  yield takeLatest(getUserHistoryData.type, getUserHistory);
}

function* watchEditUser() {
  yield takeLatest(getEditUserData.type, getEditUser);
}

function* watchDeleteUser() {
  yield takeLatest(getDeleteUserData.type, getDeleteUser);
}

function* watchAddUser() {
  yield takeLatest(getAddUserData.type, getAddUser);
}

function* watchDeleteAdminGroupUser() {
  yield takeLatest(getDeleteAdminGroupUserData.type, getDeleteAdminGroupUser);
}

function* watchGetUsersRoles() {
  yield takeLatest(getUsersRolesData.type, getUsersRoles);
}

function* watchGetPlannedOutageUsers() {
  yield takeLatest(getPlannedOutageUsersData.type, getPlannedOutageUsers);
}

function* watchAddPlannedOutageUser() {
  yield takeLatest(getAddPlannedOutageUserData.type, addPlannedOutageUser);
}

function* watchDeletePlannedOutageUser() {
  yield takeLatest(getDeletePlannedOutageUserData.type, deletePlannedOutageUser);
}

export default function* userManagementSaga() {
  yield all([
    watchAdminUsers(),
    watchAddAdminGroupUser(),
    watchGetAllUsers(),
    watchGetUserHistory(),
    watchEditUser(),
    watchDeleteUser(),
    watchAddUser(),
    watchDeleteAdminGroupUser(),
    watchGetUsersRoles(),
    watchGetPlannedOutageUsers(),
    watchAddPlannedOutageUser(),
    watchDeletePlannedOutageUser(),
  ]);
}

// Named exports for testing
export {
  getAdminUsers,
  addAdminGroupUser,
  getAllUsers,
  getUserHistory,
  getEditUser,
  getDeleteUser,
  getAddUser,
  getDeleteAdminGroupUser,
  getUsersRoles,
  getPlannedOutageUsers,
  addPlannedOutageUser,
  deletePlannedOutageUser,
  watchAdminUsers,
  watchAddAdminGroupUser,
  watchGetAllUsers,
  watchGetUserHistory,
  watchEditUser,
  watchDeleteUser,
  watchAddUser,
  watchDeleteAdminGroupUser,
  watchGetUsersRoles,
  watchGetPlannedOutageUsers,
  watchAddPlannedOutageUser,
  watchDeletePlannedOutageUser,
};